// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ChatChannel,
} from "./types";


export default __t.row({
  messageId: __t.u64().name("message_id"),
  senderId: __t.string().name("sender_id"),
  senderName: __t.string().name("sender_name"),
  get channel() {
    return ChatChannel;
  },
  text: __t.string(),
  timestamp: __t.timestamp(),
});
